import { graphql } from 'react-relay/hooks';

export const libraryMaterialsQuery = graphql`
    query materialsLibraryQuery {
        libraryMaterials {
            id
            materialID
            tempMaterialID
            name
            json
            url
            rootUrl
            materialFileName
            sellerID
            imageUrl
            imageData
            hasShaders
            sourceTextureImages {
                sceneID
                sourceID
                materialID
                url
                fileLength
            }
            textureImages {
                textureImageID
                imageUrl
                imageFileLength
            }
            shaders {
                materialID
                name
                vertex
                fragment
            }
            shaderInputs {
                inputID
                name
                shaderInputTypeID
            }
            shaderOptions {
                optionID
                name
                shaderOptionTypeID
            }
        }
    }
`;
